<template>
  <div class="data">
    <second-menu-link-content>
      <template v-slot:header>
        <span>数据</span>
      </template>
      <template v-slot:content>
        <P>数据内容</P>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
export default {
  data() {
    return {};
  },
  components: {
    SecondMenuLinkContent
  }
};
</script>

<style lang="scss" scoped>
.data {
  width: 100%;
  height: 100%;
}
</style>
